import React from "react";
import styles from "./RestaurantsSections.module.scss";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

const RestaurantsSections = ({ title, card, imageRight, ind }) => {
  return (
    <div className={styles.OurRestaurants}>
      {false && <div className={styles.title}>{title}</div>}
      <div className={styles.box + ' ' + (ind % 2 ? '': styles.odd)}>
        <div className={`${styles.littleBox} ${styles.topSquares} section_one`}>
          <div className={styles.text}>
            <div className={styles.sectionTitle}>
              <span>{card.title}</span>
            </div>
            <div className={styles.name}>{card.author}</div>
            <div className={styles.subtitle}>{card.subtitle}</div>
            <div dangerouslySetInnerHTML={{ __html: card.text }}></div>
            {card.links && card.links.length && <div className={styles.boxButtons}>
                {card.links.map( (item, ind) => <ButtonWithIcon key={'link-'+ind} link={item.link} outline={true} /> )}
            </div>}
          </div>
        </div>
        <img src={imageRight.src} alt={imageRight.alt} className="bigSection_one"></img>
      </div>
    </div>
  );
};

export default RestaurantsSections;
